import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import ReportHeading from '../ReportHeading.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { PRODUCT_SURGERY_REPORT_QUERY } from '../../../graphql.js'
import ResultsGrid from '../ResultsGrid.js'
import ParameterValues from '../ParameterValues.js'
import '../Custom.css'
import LargeRowHandler from '../LargeRowHandler.js'
import { makeInteger } from '../../../utils.js'
import TotalsRow from '../TotalsRow.js'

const PRODUCT_SURGERY_REPORT = gql(PRODUCT_SURGERY_REPORT_QUERY)

export default function ProductSurgeryReport({ location }) {
  console.log('ProductSurgeryReport rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  let total = 0

  useEffect(() => {
    getData(location, PRODUCT_SURGERY_REPORT, 'productSurgeryReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const formatter = new Intl.NumberFormat()
    console.log(results)
    const resultRows = ResultsGrid(results, 0, null, null, null, 2, null, number => total += makeInteger(number), formatter, true)
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('BosSci/productSurgeryReport/product_surgery_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '800px', margin: 'auto'}} >
          <ReportHeading title={'Product Surgery by Year Reports'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} noNumberRow={true} />
            {resultRows}
            <TotalsRow total={total} columnNumber={1} formatter={formatter}/>
          </tbody>
        </Table>
      </div>
    )
  }
}